import { useDispatch } from 'react-redux';

import PropTypes from 'prop-types';
import { isAdmin } from 'utils';

import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { setAllowMultipleDevices } from './actions';

import AdminAction from '../AdminAction';
import Switch from '../Table/Switch';

const AllowMultipleDevices = ({ person = {}, refetchPerson }) => {
  const { t } = useTransl();
  const dispatch = useDispatch();

  const { id, allowMultipleDevices } = person;

  const showAllowMultipleDevices = Boolean(
    id && isAdmin() && typeof allowMultipleDevices === 'boolean',
  );

  if (!showAllowMultipleDevices) return null;

  return (
    <Box display="flex" alignItems="center">
      <Switch
        id={id}
        value={allowMultipleDevices}
        label={<AdminAction>{t('resident.allowMultipleDevices')}</AdminAction>}
        onChange={(value, personId) =>
          setAllowMultipleDevices(dispatch, personId, value, refetchPerson)
        }
      />
    </Box>
  );
};

AllowMultipleDevices.propTypes = {
  person: PropTypes.instanceOf(Object),
  refetchPerson: PropTypes.func.isRequired,
};

export default AllowMultipleDevices;
